var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_vm._v("Selected Theme")]),_c('div',[(_vm.selectedTemplate)?_c('TemplatePreview',{staticClass:"template-summary-item",attrs:{"template":_vm.selectedTemplate},on:{"dblclick":function($event){return _vm.handleDblClick(_vm.selectedTemplate)}}}):_c('p',[_vm._v("No theme selected")])],1),_c('v-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }